import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../lib/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    const mcp = localStorage.getItem('must_change_password');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      if (mcp === 'true') setMustChangePassword(true);
    }
    setLoading(false);
    const onForce = () => setMustChangePassword(true);
    window.addEventListener('force-password-change', onForce);
    return () => window.removeEventListener('force-password-change', onForce);
  }, []);

  const login = async (phone, password) => {
    const response = await api.post('/auth/login', { phone, password });
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.user));
    setUser(response.data.user);
    if (response.data.must_change_password) {
      localStorage.setItem('must_change_password', 'true');
      setMustChangePassword(true);
    } else {
      localStorage.removeItem('must_change_password');
      setMustChangePassword(false);
    }
    return response.data;
  };

  const completePasswordChange = () => {
    localStorage.removeItem('must_change_password');
    setMustChangePassword(false);
  };

  const register = async (name, email, phone, password, role) => {
    const response = await api.post('/auth/register', { name, email, phone, password, role });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setUser(response.data.user);
    }
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('must_change_password');
    setUser(null);
    setMustChangePassword(false);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, mustChangePassword, completePasswordChange }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
